export class AddInfluencersCampaign {
  public campaign_id: number;
  public campaign_name: string;
  public description: string;
  public influencers: InfluencerCampaign[] = [];
  public is_accepted: boolean;
}

class InfluencerCampaign {
  constructor(influencer_id: number, action: string, status: string) {
  }
}



// WEBPACK FOOTER //
// ./src/models/campaign/add-influencers-campaign.ts